// extracted by mini-css-extract-plugin
export default {"fullScreenWrapper":"AdminShareJoinCode_fullScreenWrapper__sdUt4","joinCode":"AdminShareJoinCode_joinCode__Y6XrM"};